export const apiError = (err, fallback = "Something went wrong") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || String(d)).join(", ");
  if (err && !err.response) return "Network error. Please check your connection and try again.";
  return fallback;
};

export const normalizeMobile = (value) => String(value || "").replace(/\D/g, "").slice(-10);
